import * as React from 'react';

import ToastActions from 'actions/ToastActions';
// @ts-ignore
import { touch } from 'actions/touchActions';
import AvatarWithText from 'components/AvatarWithText';
import Button from 'components/Button';
import Buttons from 'components/Buttons';
import FormElement from 'components/FormElement';
import Input from 'components/Input';
import { TOUCH_KEY as NAV_TOUCH_KEY } from 'components/NavigationList/NavigationList';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithSubtext from 'components/TextWithSubtext';
import assertions from 'lib/assertions';
import RemindAPI from 'lib/RemindAPI';

import JOIN_GROUP_BY_CODE_MUTATION from './mutations/JoinGroupByCode.gql';

import './styles/JoinGroupModalRequestToJoin.scss';

type Props = {
  className: string;
  groupCode: string;
  schoolName: string | null;
  groupAvatar: React.ReactElement;
  onSubmit: () => void;
  onCancel: () => void;
};

type State = {
  message: string;
  inputLocked: boolean;
};

export default class JoinGroupModalRequestToJoin extends React.Component<Props, State> {
  inputMessageCharLimit: number = 100; // controls the number of characters allowed in the message field
  constructor(props: Props) {
    super(props);

    this.state = {
      message: '',
      inputLocked: false,
    };
  }

  handleChange(message: string, inputLocked: boolean) {
    this.setState({
      message,
      inputLocked,
    });
  }

  render() {
    const { groupAvatar, groupCode, className, schoolName } = this.props;
    const { message, inputLocked } = this.state;
    const subtextStr = schoolName ? `${groupCode} • ${schoolName}` : `${groupCode}`;

    return (
      <React.Fragment>
        <Text align="left" element="div">
          <Row>
            <div className="JoinGroupModalRequestToJoin-text">
              <AvatarWithText title={className} avatar={groupAvatar} subtext={subtextStr} />
            </div>
          </Row>

          <TextWithSubtext
            className="JoinGroupModalRequestToJoin-areaText"
            subtext="Let the class owner know who you are.">
            Include a message
          </TextWithSubtext>
        </Text>
        <Row>
          <FormElement
            element={Input}
            elementProps={{
              autofocus: true,
            }}
            validate={(data: any) =>
              assertions.lengthLesserThanOrEqualTo(
                (data as React.ChangeEvent<HTMLInputElement>).target.value,
                this.inputMessageCharLimit,
                'Your message can be up to 100 characters.'
              )
            }
            onValidChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              this.handleChange(e.target.value, false)
            }
            onInvalidChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              this.handleChange(e.target.value, true);
            }}
            label="Request to join class message for class owner"
            labelHidden
            showErrorBeforeBlur
          />
        </Row>
        <Buttons axis="y">
          <Button
            disabled={inputLocked}
            eventKey="request_to_join.join_group.request_to_join_modal.request_to_join_class.click"
            onClick={event => {
              RemindAPI.execute({
                mutation: JOIN_GROUP_BY_CODE_MUTATION,
                variables: {
                  input: { groupCode, message },
                },
              })
                .then(() => {
                  ToastActions.showSuccessToast(
                    `You've submitted your request to join ${className}`
                  );
                  this.props.onSubmit();
                  // have the navbar update itself now so we can see the pending classes.
                  // tor note: do we want a different way to do this?
                  touch(NAV_TOUCH_KEY);
                })
                .catch((err: Error) => {
                  console.log('got error on RTJ join - ', err);
                  ToastActions.showErrorToast(
                    `We were unable to process your request to join ${className}, please try again later`
                  );
                });

              event.preventDefault();
            }}>
            Request to join class
          </Button>
          <Button
            level="secondary"
            eventKey="request_to_join.join_group.request_to_join_modal.cancel.click"
            onClick={this.props.onCancel}>
            Cancel
          </Button>
        </Buttons>
      </React.Fragment>
    );
  }
}
